export const RegisterLoc = {
    pageTitle: {
        ru: 'Регистрация',
        en: 'Registration',
    },
    button: {
        ru: 'Зарегистрироваться',
        en: 'Registration',
    },
    buttonSearch: {
        ru: 'Найти',
        en: 'Search',
    },
    buttonAccept: {
        ru: 'Подтвердить и зарегистрироваться',
        en: 'Confirm and register',
    },
    __mainPageButton: {
        ru: 'Главная регистрации',
        en: 'Registration main page',
    },
    __toAuthButton: {
        ru: 'Обратно на страницу авторизации',
        en: 'Back to login page',
    },
    opportunities: {
        ru: 'После регистрации вы сможете настроить свой личный кабинет и получить персональные скидки.',
        en: 'After registration, you can set up your personal account and receive personal discounts.',
    },
    existLegal: {
        ru: 'Вы уже с нами работали',
        en: 'Already worked with us',
    },
    newLegal: {
        ru: 'Еще не работали',
        en: 'Not working yet',
    },
    not_your_company: {
        ru: 'Не ваша компания?',
        en: 'Not your company?',
    },
    registerSuccess: {
        title: {
            ru: 'Регистрация прошла успешно.',
            en: 'Success register',
        },
        text: {
            ru:
                'Ваш аккаунт успешно зарегистрирован. Теперь необходимо активировать его. На ваш телефон отправлено СМС с кодом. Введите его в поле ниже. После активации вы сможете войти в аккаунт.',
            en:
                'Your account has been successfully registered. Now you need to activate it. An SMS code has been sent to your phone. Input it in the field below. After the activation, you can log in to your account.',
        },
    },
    country: {
        russia: {
            ru: 'Россия',
            en: 'Russia',
        },
        belarus: {
            ru: 'Беларусь',
            en: 'Belarus',
        },
        kazakhstan: {
            ru: 'Казахстан',
            en: 'Kazakhstan',
        },
    },
    fieldActivity: {
        construction: {
            ru: 'Строительство',
            en: 'Construction',
        },
        industry: {
            ru: 'Промышленность',
            en: 'Industry',
        },
        agricultureAndForestry: {
            ru: 'Сельское и лесное хозяйство',
            en: 'Agriculture and forestry',
        },
        transportAndCommunication: {
            ru: 'Транспорт и связь',
            en: 'Transport and communication',
        },
        tradeAndCatering: {
            ru: 'Торговля и общественное питание',
            en: 'Trade and catering',
        },
        education: {
            ru: 'Образование',
            en: 'Education',
        },
        healthcare: {
            ru: 'Здравоохранение',
            en: 'Healthcare',
        },
    },
    form: {
        companyName: {
            ru: 'Название компании',
            en: 'Company name',
        },
        tin: {
            ru: 'ИНН',
            en: 'TIN',
        },
        bin: {
            ru: 'БИН',
            en: 'BIN',
        },
        unp: {
            ru: 'УНП',
            en: 'UNP',
        },
        city: {
            ru: 'Город',
            en: 'City',
        },
        legalAddress: {
            ru: 'Юр. адрес компании',
            en: 'Legal company address',
        },
        contactName: {
            ru: 'Контактное лицо ФИО',
            en: 'Contact Name',
        },
        phoneNumber: {
            ru: 'Номер телефона',
            en: 'Phone number',
        },
        email: {
            ru: 'E-Mail',
            en: 'E-Mail',
        },
    },
    choose: {
        personal: {
            title: {
                ru: 'ЧАСТНОЕ ЛИЦО',
                en: 'PRIVATE PERSON',
            },
        },
        legal: {
            title: {
                ru: 'ЮРИДИЧЕСКОЕ ЛИЦО',
                en: 'Legal entity',
            },
        },
        __button: {
            ru: 'Войти',
            en: 'Sign In',
        },
    },
};
